import Header from "./Header";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axiosInstance from "axios"; // This is the only axios reference you need!
import validator from 'validator';
import Cookies from 'js-cookie';
import Nprogress from 'nprogress';

Nprogress.configure({ showSpinner: false });

const Loginpage = () => {
  const [error, setError] = useState('');
  const [user, setUser] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const Navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [cookies, setCookies] = useState(false);

  const CleanInput = (value) => {
    return validator.escape(value.trim()); 
  };

  const CleanPassword = (value) => {
    return value.trim(); 
  };

  function Handlevalidation() {
    if (user.trim() === '') {
      setError("Provide Your Name!");
      return;
    }
    if (email.trim() === '') {
      setError("Provide Your Email!");
      return;
    }
    if (password.trim() === '') {
      setError("Provide Your Password!");
      return;
    }
    setError('');
    Handlelogin();
  }

  async function Handlelogin() {
    Nprogress.start();
    setLoading(true);
    try {
      // Sending request to your live Render backend
      const response = await axiosInstance.post('https://land-survey-main-server.onrender.com/login', {
        user,
        email,
        password
      });

      Nprogress.done();

      // 1. Check Admin Login Status
      if (response.data.admin_status) {
        const expire = cookies ? { expires: 7, path: '/' } : { path: '/' }; // js-cookie uses days for integer values
        Cookies.set('Admin_token', response.data.admin_token, expire);
        setError('');
        Navigate('/AdminDash');
      } 
      // 2. Check Surveyor Login Status
      else if (response.data.surveyor_status) {
        const expire = cookies ? { expires: 7, path: '/' } : { path: '/' };
        Cookies.set('Surveyor_token', response.data.surveyor_token, expire);
        setError('');
        Navigate('/Surveyordashboard');
      } 
      // 3. Check Regular User Login Status
      else if (response.data.status) {
        const expire = cookies ? { expires: 7, path: '/' } : { path: '/' };
        Cookies.set('user_token', response.data.user_token, expire);
        setError('');
        Navigate('/Landing');
      } 
      // 4. Fallback if backend responds with 200 OK but status is false
      else {
        setError(response.data.message || 'Invalid Credentials!');
      }

    } catch (err) {
      Nprogress.done();
      
      if (!err.response) {
        setError('Server Problem or Network Error!');
        return;
      }

      if (err.response.status === 429) {
        setError(err.response.data.message || 'Too many requests, please try again later.');
        return;
      }

      // Read backend validation framework error arrays/objects safely
      if (err.response.data && err.response.data.errors) {
        const { user: userErr, email: emailErr, password: passwordErr } = err.response.data.errors;
        setError(userErr?.msg || emailErr?.msg || passwordErr?.msg || 'Validation failed.');
      } else if (err.response.data && err.response.data.message) {
        setError(err.response.data.message);
      } else {
        setError('Invalid Credentials!');
      }
    } finally {
      setLoading(false);
    }
  }

  const inputStyles =
    "w-full pb-1 text-amber-400 bg-transparent border-b-2 border-white/40 focus:border-amber-400 outline-none transition-colors duration-300 autofill:bg-transparent autofill:text-amber-400 pr-10";

  return (
    <div
      className="flex flex-col justify-between w-full min-h-screen overflow-x-hidden bg-center bg-no-repeat bg-cover"
      style={{ backgroundImage: "url('/images/image20.png')" }}
    >
      <Header />

      <div className="flex items-center justify-center flex-grow px-4 py-10 md:py-16">
        <div className="w-full max-w-md p-6 border shadow-2xl sm:p-8 md:p-10 border-white/20 rounded-2xl backdrop-blur-xl bg-black/40">
          <form
            onSubmit={(e) => {
              e.preventDefault();
              Handlevalidation();
            }}
            className="flex flex-col gap-5"
          >
            <div className="text-center">
              <h2 className="mb-1 text-3xl font-bold tracking-wide text-white">
                Welcome Back
              </h2>
              <p className="text-sm text-white/60">
                Sign in to access your dashboard
              </p>
            </div>

            {error && (
              <div className="bg-red-500/20 border border-red-500/50 rounded-lg p-2.5 text-center">
                <p className="text-sm font-medium text-red-400">{error}</p>
              </div>
            )}

            <div>
              <label className="text-white/80 text-xs font-semibold uppercase tracking-wider block mb-1.5">
                User Name
              </label>
              <input
                type="text"
                required
                className={inputStyles}
                onChange={(e) => setUser(CleanInput(e.target.value))}
              />
            </div>

            <div>
              <label className="text-white/80 text-xs font-semibold uppercase tracking-wider block mb-1.5">
                User Email
              </label>
              <input
                type="email"
                required
                className={inputStyles}
                onChange={(e) => setEmail(CleanInput(e.target.value))}
              />
            </div>

            <div>
              <label className="text-white/80 text-xs font-semibold uppercase tracking-wider block mb-1.5">
                User Password
              </label>
              <div className="relative w-full">
                <input
                  type={showPassword ? "text" : "password"}
                  required
                  className={inputStyles}
                  onChange={(e) => setPassword(CleanPassword(e.target.value))}
                />
                
                <button
                  type="button"
                  className="absolute right-2 bottom-1.5 text-white/50 hover:text-amber-400 transition-colors duration-200 focus:outline-none"
                  onClick={() => setShowPassword(!showPassword)}
                  aria-label={showPassword ? "Hide password" : "Show password"}
                >
                  {showPassword ? (
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M3.98 8.223A10.477 10.477 0 0 0 1.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.451 10.451 0 0 1 12 4.5c4.756 0 8.773 3.162 10.065 7.498a10.522 10.522 0 0 1-4.293 5.774M6.228 6.228 3 3m3.228 3.228 3.65 3.65m7.894 7.894L21 21m-3.228-3.228-3.65-3.65m0 0a3 3 0 1 0-4.243-4.243m4.242 4.242L9.88 9.88" />
                    </svg>
                  ) : (
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z" />
                      <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
                    </svg>
                  )}
                </button>
              </div>
            </div>

            <div className="flex flex-wrap items-center justify-between gap-2 pt-1 text-sm">
              <div className="flex items-center gap-2">
                <input
                  type="checkbox"
                  id="rememberMe"
                  className="w-4 h-4 border-gray-300 rounded cursor-pointer text-amber-500 focus:ring-amber-500 accent-amber-500"
                  onChange={(e) => setCookies(e.target.checked)}
                />
                <label
                  htmlFor="rememberMe"
                  className="transition-colors cursor-pointer select-none text-white/90 hover:text-white"
                >
                  Remember Me
                </label>
              </div>
              <Link
                to="/forgotPassword"
                className="transition-colors duration-200 text-white/70 hover:text-red-400"
              >
                Forgot Password?
              </Link>
            </div>

            <div className="mt-2">
              <button
                type="submit"
                disabled={loading}
                className="w-full py-3 font-semibold text-black tracking-wide rounded-xl bg-gradient-to-r from-amber-400 to-yellow-500 hover:from-amber-500 hover:to-yellow-600 active:scale-[0.98] transition-all duration-200 shadow-lg shadow-amber-500/20 flex items-center justify-center gap-2"
              >
                {loading ? (
                  <div className="w-5 h-5 border-2 border-white rounded-full border-t-transparent animate-spin"></div>
                ) : (
                  "Login"
                )}
              </button>
            </div>

            <div className="mt-1 text-center">
              <Link
                to="/regist"
                className="text-sm text-white/70 hover:text-blue-400 border-b border-transparent hover:border-blue-400 transition-all duration-200 pb-0.5"
              >
                Don't Have An Account? Register
              </Link>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Loginpage;